if (!window.__ivbCartDrawerCouponBound) {
  window.__ivbCartDrawerCouponBound = true;

  const getCartDrawerCouponCodes = (cart, includeApplications = true) => {
    const codes = [];

    if (Array.isArray(cart?.discount_codes)) {
      cart.discount_codes.forEach((discount) => {
        const code = typeof discount === 'string' ? discount : discount?.code;
        const isApplicable = typeof discount === 'string' || discount?.applicable !== false;

        if (code && isApplicable && !codes.includes(code)) {
          codes.push(code);
        }
      });
    }

    if (includeApplications && Array.isArray(cart?.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach((discount) => {
        const code = discount?.title;

        if (code && !codes.includes(code)) {
          codes.push(code);
        }
      });
    }

    return codes;
  };

  const getRoute = (routeKey, fallback) => (
    window.theme?.routes?.[routeKey] || fallback
  );

  const setCartDrawerCouponLoading = (root, isLoading) => {
    if (!root) return;

    root.classList.toggle('is-loading', isLoading);
    root.querySelectorAll('input, button').forEach((element) => {
      element.disabled = isLoading;
    });
  };

  const setCartDrawerCouponMessage = (root, message, type = '') => {
    const messageElement = root?.querySelector('[data-cart-drawer-coupon-message]');
    if (!messageElement) return;

    messageElement.textContent = message;
    messageElement.dataset.type = type;
  };

  const fetchCartDrawerCart = async () => {
    const response = await fetch(`${getRoute('cart_url', '/cart')}.js`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error(`cart.js failed with status ${response.status}`);
    }

    return response.json();
  };

  const updateCartDrawerDiscount = async (discount) => {
    const response = await fetch(`${getRoute('cart_update_url', '/cart/update')}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ discount })
    });

    if (!response.ok) {
      throw new Error(`cart/update.js failed with status ${response.status}`);
    }

    await response.json();

    return fetchCartDrawerCart();
  };

  const refreshCartDrawerCouponUi = () => {
    document.dispatchEvent(new Event('cart:refresh'));

    if (window.CPB && typeof window.CPB.refresh === 'function') {
      window.CPB.refresh('cart-drawer-coupon');
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-drawer-coupon-form]');
    if (!form) return;

    event.preventDefault();

    const root = form.closest('[data-cart-drawer-coupon]');
    const input = form.querySelector('[data-cart-drawer-coupon-input]');
    const coupon = input?.value.trim();

    if (!coupon) {
      setCartDrawerCouponMessage(root, 'Introduce un cupón.', 'error');
      input?.focus();
      return;
    }

    setCartDrawerCouponLoading(root, true);
    setCartDrawerCouponMessage(root, '');

    try {
      const currentCart = await fetchCartDrawerCart();
      const currentCodes = getCartDrawerCouponCodes(currentCart, false);
      const nextCodes = currentCodes
        .filter((code) => code.toLowerCase() !== coupon.toLowerCase())
        .concat(coupon);

      const cart = await updateCartDrawerDiscount(nextCodes.join(','));
      const appliedCodes = getCartDrawerCouponCodes(cart);
      const isApplied = appliedCodes.some((code) => code.toLowerCase() === coupon.toLowerCase());

      if (!isApplied) {
        await updateCartDrawerDiscount(currentCodes.join(','));
        setCartDrawerCouponMessage(root, 'No se ha podido aplicar el cupón.', 'error');
        return;
      }

      input.value = '';
      setCartDrawerCouponMessage(root, 'Cupón aplicado.', 'success');
      refreshCartDrawerCouponUi();
    } catch (error) {
      console.error('Error aplicando cupón en el carrito:', error);
      setCartDrawerCouponMessage(root, 'No se ha podido aplicar el cupón.', 'error');
    } finally {
      setCartDrawerCouponLoading(root, false);
    }
  });

  document.addEventListener('click', async (event) => {
    const removeButton = event.target.closest('[data-cart-drawer-coupon-remove]');
    if (!removeButton) return;

    event.preventDefault();

    const root = removeButton.closest('[data-cart-drawer-coupon]');
    const codeToRemove = removeButton.dataset.cartDrawerCouponRemove;

    setCartDrawerCouponLoading(root, true);
    setCartDrawerCouponMessage(root, '');

    try {
      const currentCart = await fetchCartDrawerCart();
      const nextCodes = getCartDrawerCouponCodes(currentCart, false)
        .filter((code) => code.toLowerCase() !== codeToRemove.toLowerCase());

      await updateCartDrawerDiscount(nextCodes.join(','));
      setCartDrawerCouponMessage(root, 'Cupón eliminado.', 'success');
      refreshCartDrawerCouponUi();
    } catch (error) {
      console.error('Error eliminando cupón en el carrito:', error);
      setCartDrawerCouponMessage(root, 'No se ha podido eliminar el cupón.', 'error');
    } finally {
      setCartDrawerCouponLoading(root, false);
    }
  });
}
